import type { getFacilityStatus } from "../EnterpriseOverviewLanding/utils";

export const SCORE_MAX = 25;

export type BreakdownTone = "negative" | "warning" | "positive";

export type BreakdownRow = {
  id: string;
  label: string;
  weight: number;
  score: number | null;
  tone: BreakdownTone;
  current: string;
  target: string;
  description: string;
};

export type FacilityStatus = ReturnType<typeof getFacilityStatus>;
